/* eslint-disable */
import Vue from 'vue';
import _ from 'lodash';
import Router from 'vue-router';
import SignIn from './views/SignIn.vue';
import Events from './views/Events.vue';
import Event from './views/Event.vue';
import Registrant from './views/Registrant.vue';
import RegistrantNew from './views/RegistrantNew.vue';
import Registrants from './views/Registrants.vue';
import Reports from './views/Reports.vue';
import Order from './views/Order.vue';
import Organization from './views/Organization.vue';
import Organizations from './views/Organizations.vue';
import Season from './views/Season.vue';
import Seasons from './views/Seasons.vue';
import EventForm from './views/EventForm.vue';
import Pricing from './views/Pricing.vue';
import Communications from './views/Communications.vue';
import CommunicationEventNew from './views/CommunicationEventNew.vue';
import CommunicationEmail from './views/CommunicationEmail.vue';
import CommunicationEmailNew from './views/CommunicationEmailNew.vue';
import CCTransactions from './views/CCTransactions.vue';
import PromoCode from './views/PromoCode.vue';
import Users from './views/Users.vue';
import User from './views/User.vue';
import NotFound from './views/NotFound.vue';
import EventBus from './services/event-bus';
import Browser from './services/browser-storage-mixin';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/signin',
      name: 'signin',
      component: SignIn,
    },
    {
      path: '/',
      redirect: '/events',
    },
    {
      path: '/events',
      name: 'events',
      component: Events,
    },
    {
      path: '/events/:eventID/:tab?',
      name: 'event',
      component: Event,
    },
    {
      path: '/events/:eventID/form/:formID',
      name: 'event-form',
      component: EventForm,
    },
    {
      path: '/events/:eventID/pricing/:pricingID',
      name: 'pricing',
      component: Pricing,
    },
    {
      path: '/events/:eventID/promo-code/:promoCodeID',
      name: 'promo-code',
      component: PromoCode,
    },
    {
      path: '/registrants',
      name: 'registrants',
      component: Registrants,
    },
    {
      path: '/events/:eventID/registrant/new',
      name: 'new-registrant',
      component: RegistrantNew,
    },
    {
      path: '/events/:eventID/registrant/:registrationID',
      name: 'registrant',
      component: Registrant,
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports,
    },
    {
      path: '/orders/:registrationSessionUUID',
      name: 'order',
      component: Order,
    },
    {
      path: '/organizations',
      name: 'organizations',
      component: Organizations,
    },
    {
      path: '/organizations/:organizationID',
      name: 'organization',
      component: Organization,
    },
    {
      path: '/seasons',
      name: 'seasons',
      component: Seasons,
    },
    {
      path: '/seasons/:seasonID',
      name: 'season',
      component: Season,
    },
    {
      path: '/communications',
      name: 'communications',
      component: Communications,
    },
    {
      path: '/communications/:communicationID/:type',
      name: 'email-communication',
      component: CommunicationEmail,
    },
    {
      path: '/communications/new/Email',
      name: 'new-email-communication',
      component: CommunicationEmailNew,
    },
    {
      path: '/communications/new/event',
      name: 'event-communication',
      component: CommunicationEventNew,
    },
    {
      path: '/cc-transactions',
      name: 'cc-transactions',
      component: CCTransactions,
    },
    {
      path: '/organizers',
      name: 'organizers',
      component: Users,
    },
    {
      path: '/organizers/:userID',
      name: 'organizer',
      component: User,
    },
    {
      path: '/not-found',
      name: 'not-found',
      component: NotFound,
    },
    // always redirect to /events
    {
      path: '*',
      redirect: '/not-found',
    },
  ],
});

const checkRoute = path => new Promise((resolve, reject) => {
  const check = () => {
    if (router.app.hasRoleForRoute(path, router.app.user.permissions)) {
      resolve();
    } else {
      reject();
    }
  };

  // if user already loaded
  if (router.app.user) {
    check();
  }

  EventBus.$on('logged-in-user-changed', check);
});

router.beforeEach((to, from, next) => {
  if (to.name && to.name !== 'signin') {
    Browser.methods.sessionStorageSet('referrer', _.pick(to, ['name', 'params']));
  }

  checkRoute(to.path)
    .then(next, () => {
      next('/not-found');
    });
});

export default router;
